module.exports = __webpack_public_path__ + "static/media/ms-symbollockup_signin_light.ad23a60a.svg";